export type FeeSchedule = {
  id: number;
  feeId: number;
  day: string;
  startTime: string;
  endTime: string;
  createdAt: string;
  updatedAt: string;
};

export type FeeHours = {
  [P in Days]?: string;
};

export type Days =
  | "Monday"
  | "Tuesday"
  | "Wednesday"
  | "Thursday"
  | "Friday"
  | "Saturday"
  | "Sunday";

export type Fee = {
  id: number;
  name: string;
  active: number;
  description: string;
  price: number;
  currency: string;
  interval: string;
  intervalCount: number;
  trialPeriodDays: number;
  branchId: number;
  createdAt: string;
  updatedAt: string;
  stripeId: string;
  automatedTraining: number;
  automatedNutrition: number;
  people: number;
  app: number;
  discount: number;
  repeatDiscount: number;
  registrationPaymentId: number;
  datePause: string;
  centerAccess: number;
  installations: any;
  feeSchedules: FeeSchedule[];
  hourInit?: FeeHours;
  hourFinish?: FeeHours;
  duration?: string;
  time_start?: string;
  date_start?: string;
  date_end?: string;
  coach_id?: string;
  matricula?: string;
  trial_period_days: number;
  days?: Array<string>;
  registrationPayment?: {
    price: string;
    currency: string;
  };
};

export const currencies = [
  { id: 1, currency: "AED" },
  { id: 2, currency: "AFN" },
  { id: 3, currency: "ALL" },
  { id: 4, currency: "AMD" },
  { id: 5, currency: "ANG" },
  { id: 6, currency: "AOA" },
  { id: 7, currency: "ARS" },
  { id: 8, currency: "AUD" },
  { id: 9, currency: "AWG" },
  { id: 10, currency: "AZN" },
  { id: 11, currency: "BAM" },
  { id: 12, currency: "BBD" },
  { id: 13, currency: "BDT" },
  { id: 14, currency: "BGN" },
  { id: 15, currency: "BHD" },
  { id: 16, currency: "BIF" },
  { id: 17, currency: "BMD" },
  { id: 18, currency: "BND" },
  { id: 19, currency: "BRL" },
  { id: 20, currency: "BSD" },
  { id: 21, currency: "BTN" },
  { id: 22, currency: "BWP" },
  { id: 23, currency: "BYN" },
  { id: 24, currency: "BZD" },
  { id: 25, currency: "CAD" },
  { id: 26, currency: "CDF" },
  { id: 27, currency: "CHF" },
  { id: 28, currency: "CLP" },
  { id: 29, currency: "CNY" },
  { id: 30, currency: "COP" },
  { id: 31, currency: "CRC" },
  { id: 32, currency: "CUP" },
  { id: 33, currency: "CVE" },
  { id: 34, currency: "CZK" },
  { id: 35, currency: "DJF" },
  { id: 36, currency: "DKK" },
  { id: 37, currency: "DOP" },
  { id: 38, currency: "DZD" },
  { id: 39, currency: "EGP" },
  { id: 40, currency: "ERN" },
  { id: 41, currency: "ETB" },
  { id: 42, currency: "EUR" },
  { id: 43, currency: "FJD" },
  { id: 44, currency: "FKP" },
  { id: 45, currency: "FOK" },
  { id: 46, currency: "GBP" },
  { id: 47, currency: "GEL" },
  { id: 48, currency: "GHS" },
  { id: 49, currency: "GIP" },
  { id: 50, currency: "GMD" },
  { id: 51, currency: "GNF" },
  { id: 52, currency: "GTQ" },
  { id: 53, currency: "GYD" },
  { id: 54, currency: "HKD" },
  { id: 55, currency: "HNL" },
  { id: 56, currency: "HRK" },
  { id: 57, currency: "HTG" },
  { id: 58, currency: "HUF" },
  { id: 59, currency: "IDR" },
  { id: 60, currency: "ILS" },
  { id: 61, currency: "INR" },
  { id: 62, currency: "IQD" },
  { id: 63, currency: "IRR" },
  { id: 64, currency: "ISK" },
  { id: 65, currency: "JMD" },
  { id: 66, currency: "JOD" },
  { id: 67, currency: "JPY" },
  { id: 68, currency: "KES" },
  { id: 69, currency: "KGS" },
  { id: 70, currency: "KHR" },
  { id: 71, currency: "KPW" },
  { id: 72, currency: "KRW" },
  { id: 73, currency: "KWD" },
  { id: 74, currency: "KZT" },
  { id: 75, currency: "LAK" },
  { id: 76, currency: "LBP" },
  { id: 77, currency: "LKR" },
  { id: 78, currency: "LRD" },
  { id: 79, currency: "LSL" },
  { id: 80, currency: "LYD" },
  { id: 81, currency: "MAD" },
  { id: 82, currency: "MDL" },
  { id: 83, currency: "MGA" },
  { id: 84, currency: "MKD" },
  { id: 85, currency: "MMK" },
  { id: 86, currency: "MNT" },
  { id: 87, currency: "MOP" },
  { id: 88, currency: "MRU" },
  { id: 89, currency: "MUR" },
  { id: 90, currency: "MVR" },
  { id: 91, currency: "MWK" },
  { id: 92, currency: "MXN" },
  { id: 93, currency: "MYR" },
  { id: 94, currency: "MZN" },
  { id: 95, currency: "NAD" },
  { id: 96, currency: "NGN" },
  { id: 97, currency: "NIO" },
  { id: 98, currency: "NOK" },
  { id: 99, currency: "NPR" },
  { id: 100, currency: "NZD" },
  { id: 101, currency: "OMR" },
  { id: 102, currency: "PAB" },
  { id: 103, currency: "PEN" },
  { id: 104, currency: "PGK" },
  { id: 105, currency: "PHP" },
  { id: 106, currency: "PKR" },
  { id: 107, currency: "PLN" },
  { id: 108, currency: "PYG" },
  { id: 109, currency: "QAR" },
  { id: 110, currency: "RON" },
  { id: 111, currency: "RSD" },
  { id: 112, currency: "RUB" },
  { id: 113, currency: "RWF" },
  { id: 114, currency: "SAR" },
  { id: 115, currency: "SBD" },
  { id: 116, currency: "SCR" },
  { id: 117, currency: "SDG" },
  { id: 118, currency: "SEK" },
  { id: 119, currency: "SGD" },
  { id: 120, currency: "SHP" },
  { id: 121, currency: "SLL" },
  { id: 122, currency: "SOS" },
  { id: 123, currency: "SRD" },
  { id: 124, currency: "SSP" },
  { id: 125, currency: "STN" },
  { id: 126, currency: "SYP" },
  { id: 127, currency: "SZL" },
  { id: 128, currency: "THB" },
  { id: 129, currency: "TJS" },
  { id: 130, currency: "TMT" },
  { id: 131, currency: "TND" },
  { id: 132, currency: "TOP" },
  { id: 133, currency: "TRY" },
  { id: 134, currency: "TTD" },
  { id: 135, currency: "TWD" },
  { id: 136, currency: "TZS" },
  { id: 137, currency: "UAH" },
  { id: 138, currency: "UGX" },
  { id: 139, currency: "USD" },
  { id: 140, currency: "UYU" },
  { id: 141, currency: "UZS" },
  { id: 142, currency: "VEF" },
  { id: 143, currency: "VES" },
  { id: 144, currency: "VND" },
  { id: 145, currency: "VUV" },
  { id: 146, currency: "WST" },
  { id: 147, currency: "XAF" },
  { id: 148, currency: "XAG" },
  { id: 149, currency: "XAU" },
  { id: 150, currency: "XCD" },
  { id: 151, currency: "XDR" },
  { id: 152, currency: "XOF" },
  { id: 153, currency: "XPF" },
  { id: 154, currency: "YER" },
  { id: 155, currency: "ZAR" },
  { id: 156, currency: "ZMW" },
  { id: 157, currency: "ZWL" },
];

export const periods = [
  { id: 1, period: "weekly", name: "Semanal" },
  { id: 2, period: "biweekly", name: "Quincenal" },
  { id: 3, period: "monthly", name: "Mensual" },
  { id: 4, period: "bimonthly", name: "Bimensual" },
  { id: 5, period: "quarterly", name: "Trimestral" },
];

export const daysOfWeek = [
  { id: 1, name: "Monday", text: "Lun" },
  { id: 2, name: "Tuesday", text: "Mar" },
  { id: 3, name: "Wednesday", text: "Mié" },
  { id: 4, name: "Thursday", text: "Jue" },
  { id: 5, name: "Friday", text: "Vie" },
  { id: 6, name: "Saturday", text: "Sáb" },
  { id: 7, name: "Sunday", text: "Dom" },
];

export const colors = [
  { id: 1, color: "#A7BED3" },
  { id: 2, color: "#C6E2E9" },
  { id: 3, color: "#F1FFC4" },
  { id: 4, color: "#FFCAAF" },
  { id: 5, color: "#DAB894" },
  { id: 6, color: "#FF7477" },
  { id: 7, color: "#E69597" },
  { id: 8, color: "#CEB5B7" },
  { id: 9, color: "#B5D6D6" },
  { id: 10, color: "#9CF6F6" },
];

export function getFormatedPeriod(interval: string, intervalCount: number) {
  if (interval == "month" && intervalCount == 1) {
    return "Mensual";
  } else if (interval == "year") {
    return "Anual";
  } else if (interval == "month" && intervalCount == 6) {
    return "Bianual";
  } else if (interval == "month" && intervalCount == 3) {
    return "Trimestral";
  } else if (interval == "month" && intervalCount == 4) {
    return "Cuatrimestral";
  } else if (interval == "month" && intervalCount == 0) {
    return "Semanal";
  } else if (interval == "biweekly") {
    return "Quincenal";
  } else if (interval === "weekly") {
    return "Semanal";
  } else {
    return "Mensual";
  }
}
